import type { OeHierarchyViolation } from '../../../shared';

/**
 * Which message a failed save should show.
 *
 * The placement rule lives on the server, so a refusal can still land here
 * even though the form no longer offers the forbidden type: through the API
 * directly, or through a tree that moved under a form left open. Naming the
 * rule that was hit is worth more to whoever is looking at it than another
 * "save failed".
 *
 * The error is read structurally rather than through HttpErrorResponse. The
 * shape is the same either way, and importing it here would pull Angular into
 * this module and into anything testing it.
 */
const PLACEMENT_KEYS: Record<OeHierarchyViolation, string> = {
  TYPE_NOT_ALLOWED_UNDER_PARENT: 'organigram.errors.typeNotAllowedUnderParent',
  PARENT_TAKES_NO_CHILDREN: 'organigram.errors.parentTakesNoChildren',
  ROOT_TAKES_ONE: 'organigram.errors.rootTakesOne',
  CHILDREN_NOT_ALLOWED: 'organigram.errors.childrenNotAllowed',
  COMPANY_EMPLOYS: 'organigram.errors.companyEmploys',
  POSITIONS_NOT_ALLOWED: 'organigram.errors.positionsNotAllowed',
  STATIONS_NOT_ALLOWED: 'organigram.errors.stationsNotAllowed',
};

export const SAVE_FAILED_KEY = 'organigram.errors.saveFailed';

export function saveErrorKey(error: unknown): string {
  const code = (
    error as { error?: { data?: { code?: unknown } } } | null | undefined
  )?.error?.data?.code;
  return typeof code === 'string' && code in PLACEMENT_KEYS
    ? PLACEMENT_KEYS[code as OeHierarchyViolation]
    : SAVE_FAILED_KEY;
}
